export default {
  center: {
    textAlign: 'center'
  },
  checkbox: {
    height: '20px',
    width: '20px',
    borderRadius: '4px'
  },
  date: {
    width: '80px'
  },
  published: {
    width: '30px',
    height: '30px',
    borderRadius: '30px'
  },
  contextMenu: {
    width: '40px',
    height: '40px',
    borderRadius: '5px',
    display: 'inline-block'
  },
  ageGroup: {
    width: '82px',
    height: '31px',
    borderRadius: '4px'
  },
  thumbnailCell: {
    padding: '10px'
  },
  thumbnail: {
    width: '100%',
    height: '0',
    paddingBottom: '133%',
    borderRadius: '8px'
  },
  sta: {
    width: '40px'
  }
}
